import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  Divider,
} from "@mui/material";
import { VerifiedUser, GppMaybe } from "@mui/icons-material";
import { useAuth } from "../../hooks/auth";

export const StudentDashboard = () => {
  const { cookies } = useAuth();
  console.log(cookies);

  return (
    <>
      <Typography variant="h6">Dashboard</Typography>
      <Card
        sx={{
          minWidth: 325,
          maxWidth: 600,
          boxShadow: "2px 2px 9px -4px rgba(0,0,0,0.75)",
        }}
      >
        <CardContent>
          <Stack direction="row" spacing={1} marginTop="7px" marginBottom="7px">
            <Typography variant="body1" display="inline-block">
              {`${cookies.data.first_name} ${cookies.data.last_name}`}
            </Typography>
            {cookies.data.is_verified ? (
              <VerifiedUser />
            ) : (
              <GppMaybe sx={{ color: "orange" }} />
            )}
          </Stack>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Stack>
              <Typography>{cookies.data.matric_no}</Typography>
              <Typography
                sx={{ color: "primary.main" }}
                variant="caption"
                display="block"
              >
                Matric No.
              </Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />

            <Stack>
              <Typography>{cookies.data.meal_option}</Typography>
              <Typography
                sx={{ color: "primary.main" }}
                variant="caption"
                display="block"
              >
                Meal Option
              </Typography>
            </Stack>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack>
              <Typography>{cookies.data.transactions.length}</Typography>
              <Typography
                sx={{ color: "primary.main" }}
                variant="caption"
                display="block"
              >
                Meals Taken
              </Typography>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};
